module.exports = __webpack_public_path__ + "static/media/background-8.a3902b58.jpg";